import  React, {  Component} from "react"
import Rellax from "rellax";
import { connect } from 'react-redux'
import Section from "../Order/Section";
import cognitoUtils from '../../lib/cognito';
import Landing from "./landing";
import Confirm from "../Order/confirm";

const mainStyle = {
    backgroundColor: '#f2f3f3'
};

const mainContainerStyle = {
    backgroundColor: '#ffffff',
    paddingLeft: '0px',
    paddingRight: '0px'
};

class Home extends Component {
    orderCreated = (responseData)=>{
        this.setState({ OrderState: 1, data: responseData });
    };
    newOrder = () => {
        this.setState({ OrderState: 0, data: {} });
    }
    constructor(props) {
        super(props);
        this.state = {
            OrderState: 0, data: {}
        };
    }
    render() {
        return (
            <>
            {/* <MTSNavScrollbar /> */}

            <div style={mainStyle}>
                    <div className="container" style={mainContainerStyle}>

                        {(this.props.session.isLoggedIn == null || !this.props.session.isLoggedIn) && (< Landing />)}
                        {(this.state.OrderState == 0 && this.props.session.isLoggedIn) && (< Section complete={this.orderCreated} />)}
                        {(this.state.OrderState == 1 && this.props.session.isLoggedIn) && (< Confirm complete={this.newOrder} data={this.state.data} />)}

                </div>
            </div>
            {/* <MTSFooter /> */}
            </>
            );
    }
}


const mapStateToProps = state => {
    return { session: state.session }
}

export default connect(mapStateToProps)(Home);
